import React from 'react';

const JoinLearners = () => {
  return (
    <section className="py-12 md:py-16 lg:py-24 bg-purple-1">
      <div className="container mx-auto px-24">
        <div className="flex flex-col lg:flex-row justify-between items-center">
          <div className="lg:max-w-xl">
            <h2 className="text-title font-bold text-white">
              Rejoins la <span className="text-dark-1">première communauté </span>panafricaine de makers.
            </h2>
          </div>

          <div className="flex-shrink-0">
            <a 
              href='https://app.gonextmaker.com/auth/signup'
              className="inline-block px-6 py-3 md:px-8 md:py-4 bg-dark-1 border-2 border-dark-1 hover:bg-purple-1
               text-white text-button hover:text-dark-1 font-medium rounded-full transition-colors duration-300"
            >
              Commence ton aventure ici !
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinLearners;